<button
  nz-button
  (click)="exportSharedUserQualificationsComplementaryCertificate()"
>
  {{ 'page.qualifications.export' | translate }}
</button>
